import React from 'react';
import GalleryTab from './tabs';

export default function Gallery() {
    return (
        <div>
            <GalleryTab />
        </div>
    );
}
